import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app: any = null;
let messaging: ReturnType<typeof getMessaging> | null = null;
let isInitialized = false;

function initializeFirebaseApp() {
  if (isInitialized) return;

  console.log('[Firebase] Config:', {
    projectId: firebaseConfig.projectId,
    appId: firebaseConfig.appId,
    allKeysPresent: Object.values(firebaseConfig).every(v => !!v),
  });

  try {
    app = initializeApp(firebaseConfig);
    isInitialized = true;
    console.log('[Firebase] App initialized');
  } catch (err) {
    console.error('[Firebase] Failed to initialize app:', err);
  }
}

export async function getFirebaseMessaging() {
  // Initialize Firebase only when requesting messaging (after login)
  if (!isInitialized) {
    initializeFirebaseApp();
  }

  if (!app) {
    console.error('[Firebase] App not initialized');
    return null;
  }

  if (messaging) return messaging;

  const supported = await isSupported();
  if (!supported) {
    console.warn('[Firebase] Cloud Messaging is not supported in this environment');
    return null;
  }

  try {
    messaging = getMessaging(app);
    console.log('[Firebase] Messaging initialized');
    return messaging;
  } catch (err) {
    console.warn('[Firebase] Could not initialize messaging (service worker issue):', err);
    try {
      messaging = getMessaging(app);
      return messaging;
    } catch (err2) {
      console.error('[Firebase] Failed to get messaging:', err2);
      return null;
    }
  }
}
